<template>
  <b-card header="Cuenta personal">
    <b-row>
      <b-col sm="6">
        <b-form @submit.prevent="saveAccount()">
          <div class="form-group">
            <label for="">Nombre</label>
            <input type="text" v-model="account.name" class="form-control" required/>
          </div>
          <div class="form-group">
            <label for="">Apellido</label>
            <input type="text" v-model="account.last_name" class="form-control" required/>
          </div>
          <div class="form-group">
            <label for="">Correo</label>
            <input type="text" v-model="account.email" class="form-control" required/>
          </div>
          <div class="form-group">
            <label for="">Celular</label>
            <input type="text" v-model="account.mobile" class="form-control" />
          </div>
          <div class="form-group">
            <input type="submit" value="Guardar" class="btn btn-primary">
          </div>
        </b-form>
      </b-col>
      <b-col sm="6">
        <b-form @submit.prevent="savePassword()">
          <div class="form-group">
            <label for="">Contraseña actual</label>
            <input type="password" v-model="current_password" class="form-control" required/>
          </div>
          <div class="form-group">
            <label for="">Nueva contraseña</label>
            <input type="password" v-model="new_password" class="form-control" required/>
          </div>
          <div class="form-group">
            <label for="">Repita contraseña nueva</label>
            <input type="password" v-model="confirm_new_password" class="form-control" required/>
          </div>
          <div class="form-group">
            <input type="submit" value="Cambiar contraseña" class="btn btn-primary">
          </div>
        </b-form>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/helpers/api'
export default {
  data(){
    return {
      account: {},
      current_password: '',
      new_password: '',
      confirm_new_password: ''
    }
  },
  computed: {
    ...mapGetters(
      { 'user': 'user/user' }
    )
  },
  mounted(){
    this.account = {... this.user}
  },
  methods: {
    saveAccount(){
      delete this.account.role
      delete this.account.company
      delete this.account.provider
      api.put('/account', this.account).then(response => {
        this.$store.dispatch('user/setUser', response.user)
        this.$toastr.success('Cuenta actualizada', 'Cuenta personal', {positionClass: "toast-top-center", closeButton: true});
      }, error => {
        this.$toastr.error(error, 'Cuenta personal', {positionClass: "toast-top-center", closeButton: true});
      })
    },
    savePassword(){
      const { current_password, new_password, confirm_new_password } = this
      
      if(new_password !== confirm_new_password){
        this.$toastr.error('Debes repetir misma contraseña', 'Nueva contraseña', {positionClass: "toast-top-center", closeButton: true});
        return 
      }

      const data = {
        current_password,
        new_password,
        confirm_new_password
      }

      api.put('/change_password', data).then(response => {
        this.$toastr.success('Contraseña actualizada.', 'Contraseña', {positionClass: "toast-top-center", closeButton: true});
        this.current_password = this.new_password = this.confirm_new_password = ''
      }, error => {
        this.$toastr.error(error.message, 'Contraseña', {positionClass: "toast-top-center", closeButton: true});
      })
    },
  }
}
</script>

